<!-- @format -->

<template>
	<border-box>
		<div class="todoList">
			<div class="title">
				巡检记录
				<div v-if="!isWorkbenchedit" class="more">
					更多
					<el-icon style="font-size: 14px">
						<ArrowRightBold />
					</el-icon>
				</div>
			</div>
			<div class="list">
				<template v-if="tableData.length > 0">
					<el-row v-for="item in tableData" :key="item.id" class="detail-info" :gutter="20" @click="tableClick(item)">
						<el-col :span="12" class="left">
							{{ item.noticeTitle }}
						</el-col>
						<el-col :span="12" class="right">
							{{ item.deployTime }}
						</el-col>
					</el-row>
				</template>
				<template v-else>
					<div class="nodata">建设中</div>
				</template>
			</div>
		</div>
		<div v-show="isWorkbenchedit" class="delEdit">
			<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
		</div>
	</border-box>
</template>

<script setup name="noticeList">
	import { ref } from 'vue';
	import borderBox from './border-box.vue';
	const emit = defineEmits(['deletePanelItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
	});

	const tableData = ref([]);

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}
</script>

<style scoped lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.delEdit {
		position: absolute;
		top: 20px;
		right: 25px;
		// font-size: $app-fontsize-title;

		.el-icon {
			// color: $theme-workbench-icon-color;
			cursor: pointer;
		}
	}

	.todoList {
		height: 100%;

		.title {
			font-weight: 600;
			font-size: 16px;
			color: #ffffff;
			line-height: 20px;
			text-align: left;

			.more {
				float: right;
				//cursor: pointer;
				color: #5eebff;
			}
		}

		.list {
			height: calc(100% - 10px);
			padding: 10px;
			overflow: auto;

			.nodata {
				font-size: 16px;
				color: #ffffff;
				text-align: center;
			}

			.detail-info {
				font-size: 16px;
				color: #ffffff;
				line-height: 49px;

				.left,
				.right {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					cursor: pointer;
				}

				.right {
					text-align: right;
				}

				.left {
					&::before {
						content: '';
						width: 6px;
						height: 6px;
						background: #5eebff;
						border-radius: 50%;
						margin-right: 5px;
						display: inline-block;
						vertical-align: middle;
						margin-top: -4px;
					}
				}
			}
		}
	}
</style>
